// import { canUseDOM } from 'exenv';

export function tagPromoBannerLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_PROMO_BANNER_LOADING',
    tagPromoBanner: resp,
    store
  };
}

export function tagPromoBannerLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_PROMO_BANNER_LOADED',
    tagPromoBanner: resp.tagPromoBanner,
    store
  };
}

export function tagPromoBannerLoadError(error, store = {}) {
  return {
    type: 'TAG_PROMO_BANNER_ERROR',
    tagPromoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
